<template lang="pug">
  .color-wonder-hero.xs-12(v-if="product.id")
    .side-by-side-wrap.xs-12#step-one
      .product-imagery.xs-12.md-7
        ColorWonderPdpProductInfo(v-if="breakpoint == 'mobile' || breakpoint == 'tablet'")
        PdpCarousel(:images="mix_pdpCarouselImages")
          template(v-slot:try-it-on)
            .try-it-on-cta-wrap
              button.try-it-on-cta.btn-reset.upper.bold.cta-color-1.xs-f-small.max-at-tweak(ref="colorWonderHeroTryItOn" @click="tryItOn($refs.colorWonderHeroTryItOn)")
                mr-icon(name='circle-camera' :fill='false')
                | Try It On

      .product-info-and-cta.xs-12.md-5
        ColorWonderPdpSide.xs-12

        .transactional-info-wrap.xs-12
          PdpTransactionalInfo

        .money-back-guarantee.xs-12.xs-f-xxsmall.md-f-xsmall.max-at-tweak.xs-mt-0.lg-hide.md-hide
          .risk-free.money-back-inner.xs-12.mt-50m
            MrIcon.max-at-tweak.xs-f-large(name="cw-check" :fill="false")
            p.max-at-tweak.xs-f-xsmall.ml-25m
              span Try it risk-free with our 100% Money-Back Guarantee

          .money-back-inner.xs-12.mt-100m
            MrIcon.max-at-tweak.xs-f-large(name="cw-message" :fill="false")
            p.xs-f-xsmall.max-at-tweak.ml-25m
              span Our Color Crew is here to answer all your questions
              span.xs-hide.md-hide , from start to finish

        meta(itemprop="description"  :content="description")

        PdpPromotionalMessages.xs-12.xs-pt-100m.xs-pb-100m

        PdpCTAs(cta-source="ColorKit").xs-12

        .money-back-guarantee.xs-12.xs-f-xxsmall.md-f-xsmall.max-at-tweak.xs-hide.sm-hide.mt-50m
          .risk-free.money-back-inner.xs-12.mt-50m
            MrIcon.max-at-tweak.xs-f-large(name="cw-check" :fill="false")
            p.max-at-tweak.xs-f-xsmall.ml-25m
              span Try it risk-free with our 100% Money-Back Guarantee

          .money-back-inner.xs-12.mt-100m
            MrIcon.max-at-tweak.xs-f-large(name="cw-message" :fill="false")
            p.xs-f-xsmall.max-at-tweak.ml-25m
              span Our Color Crew is here to answer all your questions
              span.xs-hide.md-hide , from start to finish

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import ColorWonderPdpProductInfo from "./ColorWonderPdpProductInfo";
  import PdpCarousel from '@components/PDP/PdpCarousel';
  import ColorWonderPdpSide from '@components/PDP/ColorWonderPdp/ColorWonderHero/ColorWonderPdpSide';
  import PdpTransactionalInfo from '@components/PDP/PdpTransactionalInfo';
  import PdpPromotionalMessages from "@components/PDP/PdpPromotionalMessages";
  import PdpCTAs from "@components/PDP/PdpCTAs/PdpCTAs";
  import MrIcon from '@components/MrIcon';

  import PdpCarouselImageMixin from '@components/PDP/PdpCarouselImageMixin';

  export default {
    name: 'ColorWonderHero',

    components: {
      ColorWonderPdpProductInfo,
      PdpCarousel,
      ColorWonderPdpSide,
      PdpTransactionalInfo,
      PdpPromotionalMessages,
      PdpCTAs,
      MrIcon,
    },

    mixins: [PdpCarouselImageMixin],
    inject: ['getObjPropertyCatchUndefined'],

    data() {
      return {
        showHighlightsCTA: false,
        eventsTracked: false,
      };
    },

    computed: {
      ...mapState('global', ['windowData']),
      ...mapState('pdp', ['version', 'product']),
      ...mapGetters('pdp', ['showPerfectPairOnPdp', 'perfectPairGloss', 'pdpDataLoaded']),
      ...mapState('xsell', ['productXsellLoaded']),
      ...mapGetters('xsell', ['xsellGloss']),
      ...mapState('customer', ['cdata', 'refreshingCdata']),
      ...mapGetters('colorbar', ['availableAtColorbar']),
      ...mapState('colorAdvisor', ['advisorLoaded', 'colorMatches', 'colorMatchesLoaded', 'advisorCompleted']),

      showMoneyBackGuarantee() {
        return this.version == 'B';
      },

      breakpoint() {
        return this.windowData.breakpoint;
      },

      description() {
        return (
          this.getObjPropertyCatchUndefined(this.product, 'desc.long') || this.getObjPropertyCatchUndefined(this.product, 'desc.short')
        );
      },

      bestMatch() {
        return this.cdata.bestColorMatch || {};
      },

      showAvailableInRegionCTA() {
        return this.availableAtColorbar(this.product.code);
      },
    },

    mounted() {
      this.refreshCustomerCdata();
    },

    methods: {
      ...mapActions('customer', ['refreshCustomerCdata']),
      ...mapActions('pdp', ['openPlaygroundModal']),

      tryItOn(elementRef) {
        this.openPlaygroundModal({
          returnFocusElement: elementRef,
        });
      }
    },
  };
</script>

<style scoped lang="stylus">
  .color-wonder-hero
    .side-by-side-wrap
      padding-top 2em

    .back-to-advisor
      padding-bottom 1.5em

    .try-it-on-cta-wrap
      border 4px solid transparent
      margin-top -9px

      .try-it-on-cta
        width 100%
        background-color cw-color-12
        text-align center
        padding 1em

        .mr-icon
          font-size 1.25em
          margin-top -0.25em
          margin-right 0.25em

    .transactional-info-wrap
      position relative
      padding 1em 3%
      margin-top 1.25em

      &:before
        content ''
        position absolute
        top 0
        left 0
        right 0
        border-top 1px solid ui-color-5

      &:after
        content ''
        position absolute
        bottom 0
        left 0
        right 0
        border-top 1px solid ui-color-5

    .money-back-guarantee-alert-inner
      background-color ui-color-3
      padding 0.5rem
      display flex
      align-items center
      justify-content center

      .mr-icon
        padding-right 0.5rem

    @media mq-tablet-plus
      padding-left 3%
      padding-right 3%

    @media mq-mobile
      .try-it-on-cta-wrap
        .try-it-on-cta
          position relative
          left 50%
          width 54%
          margin-left -27%

  .auto-delivery-container
    margin-top 1em

  .money-back-guarantee
      padding-bottom 1.5em
      color cw-color-11!important

      &:before
        content ''
        position absolute
        top 0
        left 0
        right 0
        border-top 1px solid ui-color-5

      .money-back-inner
        position relative
        padding-left 2.6em
        padding-right 1em

        :deep(.mr-icon)
          margin-top 0.1rem
          position absolute
          left 0.5em

        &.line
          border-left 1px solid ui-color-5

    .product-info-and-cta
      .info-section
        margin-top 1em

    @media mq-mobile
      .switch-on-mobile
        display flex
        flex-direction column-reverse
        .money-back-guarantee
          padding-top 1.5em;

    @media mq-tablet-less
      .side-by-side-wrap
        padding-top 0

      .product-info-and-cta
        .info-section
          position relative
          margin-top 1em

          &.t-line
            &:before
              content ''
              position absolute
              top 0
              left 0
              right 0
              border-top 1px solid ui-color-5

      .auto-delivery-container
        padding 1em 5%

      .money-back-guarantee
        margin-top 1em
        padding 1.5em 5% 0

        .money-back-inner
          padding-right 0.5em

          :deep(.mr-icon)
            left 0.25em

    @media mq-tablet
      .product-info-and-cta
        padding-left 6%
        padding-right 6%

      .highlights-cta-wrap
        padding-left 5%
        padding-right 5%

      .product-bullets
        padding-left 10%
        padding-right 10%

      .money-back-guarantee
        padding-left 8%
        padding-right 8%

    @media mq-desktop-md-plus
      .money-back-guarantee
        .risk-free
          padding-top 0.5em

      .product-imagery
        padding-right 1em
        position sticky
        top 3em

      .product-bullets
        ul
          li
            width 24em

    @media mq-desktop-md
      .money-back-guarantee
        padding-top 0.5em

        .money-back-inner
          padding-left 3.2em
          padding-right 1em

          :deep(.mr-icon)
            left 0.25em

    @media mq-desktop-plus
      .product-imagery
        padding-right 2em

      .product-bullets
        padding 1.5em 3%

        ul
          li
            width 25em

      .money-back-guarantee
        padding-top 0.5em

</style>
